<template>
    <AppDefaultLayout />
</template>
